<template>
  <div class="Home">
    <div class="content">
      <h1>Scientific Design</h1>
      <p>Science stuff applied to user centered interaction design :)</p>
      <router-link to="/works">
        Explore projects
      </router-link>
    </div>
  </div>
</template>
<script>

export default {
  name: 'Home',
  components: {
  },
  data() {
    return {
    };
  },
  created() {
  },
  mounted() {
    this.$nextTick(()=> {
    });
  },
  methods: {
  }
};
</script>
<style src="../styles/views/Home.styl" lang="stylus"></style>
